import React from 'react';
import MainPanel from './MainPanel';
import SettingsPanel from './SettingsPanel';
import { useCookies } from 'react-cookie';
import T from '../components/T';

const initialExpandedState = {
  essential: false,
  marketing: false,
  analytic: false
};

const cookieName = 'cookie-consent';
const cookieExpiration = 60 * 60 * 24 * 30; // 30 days


const CookieConsent = () => {
  const [showSettings, setShowSettings] = React.useState(false);
  const [infoExpanded, setInfoExpanded] = React.useState(false);
  const [expandedState, setExpandedState] = React.useState(initialExpandedState);
  const [marketing, setMarketing] = React.useState(false);
  const [analytic, setAnalytic] = React.useState(false);
  const [cookies, setCookie] = useCookies([cookieName]);

  const cookie = cookies[cookieName] || '';

  if (cookie) {
    return null;
  }

  const setCookieConsent = (value) => {
    setCookie(cookieName, value, {
      maxAge: cookieExpiration,
      sameSite: 'strict',
      path: '/'
    });
    window.location.reload();
  };

  return (
    <div className="cookie-background">
      <div className="cookie-consent">
        <em><T msg="cookieConsent.common.title" /></em>
        {!showSettings && <MainPanel
          onShowSettings={() => {
            setShowSettings(true);
          }}
          infoExpanded={infoExpanded}
          setInfoExpanded={(newInfoExpanded) => {
            setInfoExpanded(newInfoExpanded);
          }}
          setCookieContent={setCookieConsent}
        />}
        {showSettings && <SettingsPanel
          marketing={marketing}
          analytic={analytic}
          onChangeSelection={(newState) => {
            setAnalytic(newState.analytic);
            setMarketing(newState.marketing);
          }}
          onBack={() => {
            setShowSettings(false);
          }}
          expandedState={expandedState}
          setExpanded={(stateUpdate) => {
            setExpandedState({ ...expandedState, ...stateUpdate })
          }}
          setCookieContent={setCookieConsent}
        />}
      </div>
    </div>
  );
};

export default CookieConsent;




// WEBPACK FOOTER //
// ./app/Assets/js/features/cookieConsent/index.js